var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShuffel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.0656 5.4118 0.0656 5.4118 2.4746 0 2.4746"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0.4647 18.2425 0.4647 18.2425 13.9997 0 13.9997"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "0.3875 0.939 10.2425 0.939 10.2425 8.0097 0.3875 8.0097"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 12.061200)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4258,0.0656 C4.1978,0.2006 3.9498,0.3076 3.6648,0.3886 C3.4408,0.4516 3.3578,0.4546 1.7178,0.4666 L-0.0002,0.4766 L-0.0002,1.4756 L-0.0002,2.4746 L1.7938,2.4616 C3.4768,2.4486 3.6038,2.4456 3.8928,2.3836 C4.4448,2.2646 4.9498,2.0556 5.4118,1.7856 C5.0078,1.2696 4.6758,0.6926 4.4258,0.0656",
    id: "Fill-1",
    fill: "#0BC7C2",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 3.061200)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7075,13.9997 L13.2925,12.5857 L14.4315,11.4467 L12.8015,11.4467 L11.5025,11.4487 C10.3305,11.4367 10.1705,11.4267 9.8955,11.3677 C8.1145,10.9867 6.7425,9.7657 6.1665,8.0487 C6.0195,7.6117 5.9415,6.1557 5.9085,5.5287 C5.8775,4.9317 5.8255,4.6577 5.6655,4.2797 C5.5265,3.9457 5.3145,3.6367 5.0345,3.3527 C4.6435,2.9557 4.2225,2.7087 3.6655,2.5497 C3.4405,2.4877 3.3575,2.4837 1.7175,2.4717 L-0.0005,2.4627 L-0.0005,1.4637 L-0.0005,0.4647 L1.7935,0.4767 C3.4775,0.4897 3.6035,0.4927 3.8925,0.5547 C5.6775,0.9417 7.0505,2.1657 7.6225,3.8857 C7.7705,4.3327 7.8445,4.7697 7.8775,5.3967 C7.8955,5.7557 7.9275,7.0277 7.9675,7.1837 C8.2405,8.2647 9.0315,9.0667 10.1205,9.3757 C10.3365,9.4357 10.4405,9.4687 11.5735,9.4817 L12.7945,9.4817 L14.4315,9.4817 L13.2925,8.3427 L14.7075,6.9287 L18.2425,10.4647 L14.7075,13.9997 Z",
    id: "Fill-4",
    fill: "#0BC7C2",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(8.000000, 0.061200)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.3745,5.8967 C1.6025,5.7577 1.8485,5.6407 2.1205,5.5637 C2.3365,5.5037 2.4405,5.4697 3.5735,5.4577 L4.7945,5.4577 L6.4315,5.4577 L5.2925,6.5957 L6.7075,8.0097 L10.2425,4.4747 L6.7075,0.9387 L5.2925,2.3537 L6.4315,3.4917 L4.8015,3.4917 L3.5025,3.4897 C2.3305,3.5027 2.1705,3.5117 1.8955,3.5707 C1.3495,3.6887 0.8465,3.8937 0.3875,4.1587 C0.7925,4.6807 1.1245,5.2627 1.3745,5.8967",
    id: "Fill-7",
    fill: "#0BC7C2",
    mask: "url(#mask-6)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShuffel);
export default __webpack_public_path__ + "static/media/shuffel.78d46b6970ca683a2db45a0cc8fb0386.svg";
export { ForwardRef as ReactComponent };